module.exports = __webpack_public_path__ + "assets/img/tit3.3b2d5638.png";